import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { Button } from "reactstrap";
import Loading from "../loader/loader.js";

const Skufilter = ({
  show = false,
  searchBy,
  onHide,
  saveButtonClicked,
  type,
  setType,
  value,
  setValue,
  options,
  CategorySelect,
  setFilterLength,
  filterLength,
  setNoOfFiltersSelected,
  filtercategoryValue,
  setFilterCategoryValue,
  itemloading,
}) => {
  const typeList = options.filter((item) => {
    return item.value != searchBy.value;
  });

  return (
    <>
      <Modal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rak-beneficiary-modal"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select
            closeMenuOnSelect={true}
            isMulti
            placeholder="Type"
            onChange={(data) => {
              let length = data && data.length;

              if (data) {
                CategorySelect(data[length - 1].value, "filter");
              } else {
                setFilterCategoryValue([]);
              }
              setType(data);
              setFilterLength((prevState) => ({
                ...prevState,
                typeLength: (data && data.length) || "",
              }));
            }}
            options={typeList}
            value={type}
          />
        </Modal.Body>
        <Modal.Body>
          <></>
          {!itemloading ? (
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Value"
              onChange={(data) => {
                setValue(data);
                setFilterLength((prevState) => ({
                  ...prevState,
                  valuelength: (data && data.length) || "",
                }));
              }}
              value={value}
              options={filtercategoryValue}
            />
          ) : (
            <div
              style={{
                height: "4vh",
                display: "flex",
                placeContent: "center",
              }}
            >
              <Loading color="white" width="15px" height="15px" />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setFilterCategoryValue([]);
              setValue([]);
              setType([]);
              onHide();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              let temp =
                (filterLength.typeLength || 0) +
                (filterLength.valuelength || 0);
              setNoOfFiltersSelected(temp);
              temp = 0;
              saveButtonClicked();
            }}
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Skufilter;
